<template>
<div class="profiletable__row flex">
  <div class="profiletable__row__data flex-auto flex flex-nowrap items-center w-full" :class="bgColor">
    <AttributeIcon :size="40" :attributeKey="attributeKey"></AttributeIcon>
    <div class="flex-auto pl-20">
      <span class="font-serif text-lg leading-snug">{{ attributeTitle }}</span> <span class="pl-10 text-sm" v-html="attributeValue"></span>
    </div>
  </div>
</div>
</template>

<script>
import AttributeIcon from './../shared/icons/AttributeIcon.vue'
import Vue from 'vue'

export default {
  components: {
    AttributeIcon
  },
  'name': 'profile-table-row',
  'props': {
    'attribute-key': {
      type: String,
      required: false
    },
    dataset: {
      required: true
    }
  },
  computed: {
    bgColor () {
      let color = Vue.filter('valueColor')(this.attributeValue)
      return ['bg--' + color]
    },
    typeIcon () {
      return 'impact'
    },
    incidents () {
      return [
        'Lorem ipsum',
        'dolor sit amet'
      ]
    },
    attributeValue () {
      return this.dataset && this.dataset[this.attributeKey] ? Math.round(this.dataset[this.attributeKey] * 100) / 100 : ''
    },
    attributeTitle () {
      let label = this.$store.getters['attributes/getLabelFromKey'](this.attributeKey)
      return label ? label.name : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/covid19/ProfiletableAttributeHeader.vue